module.exports = __webpack_public_path__ + "images/9cc00f9cdd0358a0283bb99a525c6307.svg";